export default{
  user_getVcodeByPhone:{
    type:'formDataPost'
  },
  user_updatePhone:{
    type:'formDataPost'
  },
  user_updatePwd:{
    type:'formDataPost'
  },
  user_updateImage:{
    type:'upload'
  },
  user_getPersonInfo:{
    type:'formDataPost'
  }
}


// WEBPACK FOOTER //
// ./src/service/modules/userInfo.js